<template>
	<div class="_create-boarding _modal bg-white">
		<div
			class="
				_modal__content
				md-down:px-4
				px-12
				py-6
				flex flex-col
				items-center
				justify-center
			"
		>
			<div>
				<img
					alt="Luca Education"
					height="60"
					src="@/assets/images/illustrations/warning.png"
					title="Luca Education"
					width="60"
				/>
			</div>
			<div
				class="
					_modal__content__title
					text-neutral-700
					font-semibold
					text-2xl
					mt-5
					text-center
				"
			>
				Bạn có chắc chắn muốn thoát?
			</div>
			<div class="text-center text-neutral-400 mt-2 tracking-wide">
				Biểu mẫu bạn đang soạn chưa được lưu. Bạn có muốn lưu bản nháp
				trước khi thoát?
			</div>
		</div>
		<div
			class="
				_modal__footer
				px-12
				py-6
				bg-neutral-50
				flex flex-nowrap
				items-center
			"
		>
			<button
				v-if="isExit"
				class="
					button-p
					text-center
					mr-3
					bg-none
					shadow-none
					text-neutral-500
					hover:text-neutral-700
				"
				type="button"
				@click="$emit('close')"
			>
				Huỷ
			</button>
			<button
				v-if="isExit"
				class="button-p text-center whitespace-nowrap"
				type="button"
				@click="$emit('back')"
			>
				Thoát
			</button>
			<button
				v-if="!isExit"
				class="
					button-p
					text-center
					mr-3
					bg-none
					shadow-none
					text-neutral-500
					hover:text-neutral-700
				"
				type="button"
				@click="$emit('back')"
			>
				Thoát
			</button>
			<button
				v-if="!isExit"
				class="button-p text-center whitespace-nowrap"
				type="button"
				@click="$emit('submit')"
			>
				Lưu bản nháp
			</button>
		</div>
	</div>
</template>

<script>
export default {
	name: 'ExitConfirm',

	props: {
		isExit: {
			type: Boolean,
			required: true,
		},
	},
};
</script>
